import React, {
  useCallback, useContext, useMemo
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar,
  FuneralDispositionDisplay,
  ModalFormHeader, ScreenHeader
} from '../../components';
import { useUpdate } from '../../hooks';

import { NewFAContext } from '.';

export function NewFASummary({ isContinue = false }) {
  const navigate = useNavigate();
  const { funeralArrangement, update } = useContext(NewFAContext);
  const { handleUpdate } = useUpdate('funeral_arrangements');

  const handleCancel = useCallback(() => {
    if (isContinue) {
      navigate('/home');
    }
    
    return navigate('../financial-planning');
  }, [ isContinue, navigate ]);

  const handleNext = useCallback(async () => {
    if (isContinue) {
      return navigate('../disposition');
    }
    
    navigate('/home');
  }, [ isContinue, navigate ]);
  
  const subtitle = isContinue ? 'Continue from where you left off...' : 'Review your choices';

  const summarySections = useMemo(() => [
    {
      icon: 'deceased',
      header: 'Disposition Arrangements',
      details: <FuneralDispositionDisplay funeralArrangement={funeralArrangement} />
    },
    {
      icon: 'celebration',
      header: 'Ceremony Arrangements',
      details: funeralArrangement?.ceremony_preference || 'Not specified'
    },
    {
      icon: 'edit_note',
      header: 'Obituary Arrangements',
      details: funeralArrangement?.obituary_preference || 'Not specified'
    },
    {
      icon: 'money_bag',
      header: 'Financial Arrangements',
      details: funeralArrangement?.financial_planning || 'Not specified'
    }
  ], [ funeralArrangement ]);

  return (
    <div className="new-will-summary-screen screen">
      <ScreenHeader
        title="Summary"
        description={subtitle}
      />

      

      <div className="summary-content">
        {summarySections.map((section, index) => (
          <div key={index} className="form-container">
            <ModalFormHeader
              icon={section.icon}
              header={section.header}
            />
            {section.details}
          </div>
        ))}
      </div>

      <ButtonBar 
        handlePrimary={handleNext} 
        handleSecondary={handleCancel}
        primaryText={isContinue ? 'Continue' : 'Complete'}
      />
    </div>
  );
}